import DocumentPage from "../../../../invoice/DocumentPage";
import { sdiRegularInvoiceConfig } from "./config";

const SDIRegularInvoice = () => (
  <DocumentPage config={sdiRegularInvoiceConfig} />
);

export default SDIRegularInvoice;
